import api from '@app/api/routes/api';
import type { GetRecentMceEventsResponse } from './recentMceEvents.types';

/**
 * Récupère les derniers événements MCE en cours (non clôturés) accessibles à l'utilisateur,
 * sous une forme aplatie destinée à l'aperçu "Activité récente".
 */
export const getRecentMceEvents = async (): Promise<GetRecentMceEventsResponse> =>
  api.getRaw<GetRecentMceEventsResponse>('/mce/events/recent');
